import UntrackedModel from "~/models/untracked/untrackedModel";
import Role from "~/models/role";
import {IMemberModel, IMemberInvitation, IMembershipModel, IOrganization} from '~/interfaces/organizationInterfaces';
import UserDefinition from '~/definitions/userDefinition'

export default class Membership extends UntrackedModel implements IMembershipModel {
  member: IMemberModel;
  invitation: IMemberInvitation;
  role_ids: string[];
  active: boolean;
  capabilities: [];

  get hasMemberOrInvitation(): boolean {
    return !!this.member || !!this.invitation;
  }

  get email(): string {
    return UserDefinition.email(this.member, this.invitation);
  }

  get organization(): IOrganization {
    return this.parent.organization;
  }

  get isPendingMember() {
    return !this.member.id && this.invitation && !this.active
  }

  get isGroupOwner(): boolean {
    return this.parent.isGroup && this.role_ids.includes(this.parent.ownerRoleId);
  }

  get isOrganizationOwner(): boolean {
    return this.organization && this.role_ids.includes(this.organization.organization_owner_role_id)
  }

  isRole(role: Role): boolean {
    return this.role_ids.includes(role.id);
  }

  addRole(role: Role): void {
    this.role_ids.push(role.id);
  }

  removeRole(role: Role): void {
    this.role_ids.splice(this.role_ids.indexOf(role.id), 1);
  }

  setRoles(roles: Role[]): void {
    this.role_ids = roles.map(r => r.id);
  }

  get roles(): Role[] {
    return this.organization.roles.filter(r => this.role_ids.includes(r.id));
  }

  get parentIds() {
    const props = {organizationId: this.organization.id, groupId: null};
    if (this.parent.isGroup) {
      props.groupId = this.parent.id;
    }
    return props;
  }

  get noRolesName(): string {
    return 'Member';
  }
}
